module.exports = __webpack_public_path__ + "7c721d9922be62a968d279c7cfef9bbb.otf";